export enum SubmissionStateEnum {
  New = 'new',
  Previous = 'previous'
}
